import { ELECTRIC_SCOOTER_INTRO_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/ElectricScooter";
import { ElectricScooterProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/ElectricScooter/ProductIntro/interface";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export interface ElectricScooterProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;

  modelYear: number;
  brand: string;
  model: string;

  damageCountRecentYears: number;
  yearOfLastDamage?: number;
}

export const mapToCommerceElectricScooter = (
  data: Record<string, any>,
): ElectricScooterProductBackend => {
  const electricScooterIntroData: ElectricScooterProductIntroFormValues =
    data.formData[ELECTRIC_SCOOTER_INTRO_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER,
    coverageGroup: data.coverage,

    modelYear: Number(electricScooterIntroData.modelYear),
    brand: electricScooterIntroData.brand,
    model: electricScooterIntroData.model,

    ...mapFormToInjuries(
      electricScooterIntroData.injuries,
      electricScooterIntroData.injuryYear,
    ),
  };
};
